import React from 'react';

import { useAppSelector, useTranslation, useAppDispatch } from 'client/hooks';
import { setBannerJoinState, setPopup } from 'client/redux/ui';
import { selectAuth } from 'client/redux/user/selectors';
import { selectUI } from 'client/redux/ui/selectors';
import { State as AuthState } from 'client/components/common/Login/state';

import BannerLayout from '../BannerLayout';

import css from './BannerJoin.module.scss';

const BannerJoin = () => {
  const { translate } = useTranslation();
  const dispatch = useAppDispatch();
  const auth = useAppSelector(selectAuth);
  const { bannerJoin } = useAppSelector(selectUI);

  const onLoginClick = (type: AuthState['authType']) => {
    dispatch(setPopup({ type: 'auth', data: { initialAuthType: type } }));
  };

  const onCloseBtnClick = () => dispatch(setBannerJoinState('hidden'));

  return (
    <BannerLayout visible={!auth.isLoggedIn && bannerJoin === 'visible'} onCloseClick={onCloseBtnClick}>
      <p className={css.text}>
        {translate(`bannerJoin.text`)}
        <span onClick={() => onLoginClick('sign-up')}>{translate(`bannerJoin.buttonLabel`)}</span>
      </p>
    </BannerLayout>
  );
};

export default BannerJoin;
